function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M9.152 0q0.224 0 0.384 0.16t0.192 0.416v26.272q0 0.352-0.32 0.512l-8.576 4.576q-0.128 0.064-0.256 0.064-0.224 0-0.416-0.16t-0.16-0.416v-26.272q0-0.352 0.32-0.512l8.544-4.576q0.128-0.064 0.288-0.064zM31.424 0q0.224 0 0.416 0.16t0.16 0.416v26.272q0 0.352-0.288 0.512l-8.576 4.576q-0.128 0.064-0.288 0.064-0.224 0-0.384-0.16t-0.192-0.416v-26.272q0-0.352 0.32-0.512l8.576-4.576q0.128-0.064 0.256-0.064zM11.424 0q0.16 0 0.256 0.064l9.152 4.544q0.32 0.192 0.32 0.544v26.272q0 0.224-0.192 0.416t-0.384 0.16q-0.16 0-0.256-0.064l-9.152-4.544q-0.32-0.192-0.32-0.544v-26.272q0-0.224 0.192-0.416t0.384-0.16z"
});

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-map",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.2fa5e8a2.svg";
export { ForwardRef as ReactComponent };